module.exports = {"title":"Our Produce","subtitle":"Guaranteed to meet your freshness and quality expectations"}